import { loadableWithFallback } from '@vision/ui/utils';
import type { BarChart1Props } from './BarChart1';

export const BarChart1 = loadableWithFallback<BarChart1Props>(() => import('./BarChart1'));
